import {
  GET_ALL_BID_AUCTIONS,
  GET_ALL_CATEGORIES,
  GET_ALL_PAST_AUCTIONS,
  GET_ALL_RUNNING_AUCTIONS,
  GET_ALL_USERS,
  GET_ANALYTICS_DATA,
  GET_BADGE_LISTS,
  GET_BID_TOTAL,
  GET_CONTACT_LISTS,
  GET_ITEM_LISTING,
  GET_ITEM_TOTAL,
  GET_LOGS_DATA,
  GET_NEWSLETTER_LISTS,
  GET_ORDER_LISTS,
  GET_PAST_TOTAL,
  GET_PAYMENT_LISTS,
  GET_RUNNING_TOTAL,
  GET_SINGLE_STAFF,
  GET_STAFF_LISTING,
  GET_TOTAL_CATEGORIES,
  GET_TOTAL_USERS,
  USER_DISPUTES,
  USER_FLAG_COMMENTS,
  VIEW_ITEM_DETAIL,
  GET_ALL_BRAND,
  GET_TRACK_STATUS,
  GET_DISPUTE_DATA,
  GET_ORDER_DETAIL,
  GET_DISPUTE_DETAIL,
  GET_SIZES,
  GET_LEDGER,
  GET_RETURN_DATA,
  GET_BULK_DATA,
  RETURN_ORDER_DETAIL,
  GET_BULK_DETAIL,
  GET_BULK_ITEMS,
  GET_STRIKE_DATA,
  GET_RESTRICTION_DATA,
  GET_ORDER_AUDIT_LOGS,
} from "./userTypes";

const initialState = {
  allUsers: [],
  totalUsers: 0,
  itemdetail: null,
  itemdata: [],
  pastdata: [],
  runningdata: [],
  itemTotal: 0,
  runningTotal: 0,
  pastTotal: 0,
  biddata: [],
  bidtotal: 0,
  categoriesList: [],
  totalCategories: 0,
  badgeLists: [],
  staffList: [],
  staffTotal: 0,
  singleStaff: null,
  disputes: [],
  disputesTotal: 0,
  flags: [],
  flagsTotal: 0,
  newsletterLists: [],
  totalNewsletters: 0,
  contactLists: [],
  totalContacts: 0,
  contactStats: null,
  orderLists: [],
  totalOrders: 0,
  paymentLists: [],
  totalPayments: 0,
  analyticsData: null,
  logsData: [],
  totalLogs: 0,
  brandList: [],
  trackstatus: [],
  disputeData: [],
  totalDispute: 0,
  orderDetail: [],
  disputeDetail: [],
  totalbrands: 0,
  sizesData: [],
  totalSizes: 0,
  ledgerData: [],
  totalLedger: 0,
  bulkData: [],
  totalBulkData: 0,
  return_items_data: [],
  total_return_items: 0,
  return_order_detail: [],
  bulkDataDetail: [],
  bulkItems: [],
  totalBulkItems: 0,
  strikeData: [],
  restrictionData: [],
  orderAuditLogs: [],
  totalOrderAuditLogs: 0,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_USERS:
      return {
        ...state,
        allUsers: action.payload,
      };
    case GET_LEDGER:
      return {
        ...state,
        ledgerData: action.payload,
        totalLedger: action.payload.total,
      }
    case GET_BULK_DETAIL:
      return {
        ...state,
        bulkDataDetail: action.payload,
      };
    case GET_STRIKE_DATA:
      return {
        ...state,
        strikeData: action.payload,
      };
    case GET_RESTRICTION_DATA:
      return {
        ...state,
        restrictionData: action.payload,
      };
    case GET_BULK_ITEMS:
      return {
        ...state,
        bulkItems: action.payload.data,
        totalBulkItems: action.payload.length,
      };

    case RETURN_ORDER_DETAIL:
      return {
        ...state,
        return_order_detail: action.payload,
      };
    case GET_RETURN_DATA:
      return {
        ...state,
        return_items_data: action.payload.data,
        total_return_items: action.payload.pagination.total,
      };
    case GET_SIZES:
      return {
        ...state,
        sizesData: action.payload.data,
        totalSizes: action.payload.pagination.total
      };
    case GET_TOTAL_USERS:
      return {
        ...state,
        totalUsers: action.payload,
      };
    case GET_ORDER_AUDIT_LOGS:
      return {
        ...state,
        orderAuditLogs: Array.isArray(action.payload?.timeline) ? action.payload.timeline : [],
        totalOrderAuditLogs: Number(action.payload?.count) || action.payload?.timeline?.length || 0,
      };
    case VIEW_ITEM_DETAIL:
      return {
        ...state,
        itemdetail: action.payload,
      };
    case GET_ITEM_LISTING:
      return {
        ...state,
        itemdata: action.payload,
      };
    case GET_ITEM_TOTAL:
      return {
        ...state,
        itemTotal: action.payload,
      };
    case GET_ALL_PAST_AUCTIONS:
      return {
        ...state,
        pastdata: action.payload,
      };
    case GET_BULK_DATA:
      return {
        ...state,
        bulkData: action.payload.data,
        totalBulkData: action.payload.pagination.total
      };
    case GET_PAST_TOTAL:
      return {
        ...state,
        pastTotal: action.payload,
      };
    case GET_ALL_RUNNING_AUCTIONS:
      return {
        ...state,
        runningdata: action.payload,
      };
    case GET_RUNNING_TOTAL:
      return {
        ...state,
        runningTotal: action.payload,
      };
    case GET_ALL_BID_AUCTIONS:
      return {
        ...state,
        biddata: action.payload,
      };
    case GET_BID_TOTAL:
      return {
        ...state,
        bidtotal: action.payload,
      };
    case GET_ALL_CATEGORIES:
      return {
        ...state,
        categoriesList: action.payload,
      };
    case GET_ALL_BRAND:
      return {
        ...state,
        brandList: action.payload.data,
        totalbrands: action.payload.pagination.total,
      };
    case GET_TOTAL_CATEGORIES:
      return {
        ...state,
        totalCategories: action.payload,
      };
    case GET_BADGE_LISTS:
      return {
        ...state,
        badgeLists: action.payload,
      };
    case GET_STAFF_LISTING:
      return {
        ...state,
        staffList: action.payload.data?.filter(r => r.id !== action.payload.uid),
        staffTotal: Number(action.payload.length || 0),
      };
    case GET_SINGLE_STAFF:
      return {
        ...state,
        singleStaff: action.payload,
      };

    case GET_ORDER_DETAIL:
      return {
        ...state,
        orderDetail: action.payload,
      };
    case GET_DISPUTE_DETAIL:
      return {
        ...state,
        disputeDetail: action.payload,
      };
    case USER_DISPUTES:
      return {
        ...state,
        disputes: action.payload.data,
        disputesTotal: action.payload.total
      };
    case USER_FLAG_COMMENTS:
      return {
        ...state,
        flags: action.payload.list,
        flagsTotal: action.payload.total || action.payload.list.length
      };
    case GET_NEWSLETTER_LISTS:
      return {
        ...state,
        newsletterLists: action.payload.data,
        totalNewsletters: Number(action.payload.length)
      };
    case GET_CONTACT_LISTS:
      return {
        ...state,
        contactLists: action.payload.data,
        totalContacts: Number(action.payload.length || action.payload.total || action.payload.count || action.payload.pagination?.total || 0),
        contactStats: action.payload.stats || action.payload.counts || action.payload.status_counts || action.payload.statusCounts || null,
      };
    case GET_ORDER_LISTS:
      return {
        ...state,
        orderLists: action.payload.data,
        totalOrders: Number(action.payload.length)
      };
    case GET_PAYMENT_LISTS:
      return {
        ...state,
        paymentLists: action.payload.data,
        totalPayments: Number(action.payload.length)
      };
    case GET_ANALYTICS_DATA:
      return {
        ...state,
        analyticsData: action.payload.data,
      };
    case GET_LOGS_DATA:
      return {
        ...state,
        logsData: action.payload.data,
        totalLogs: action.payload.pagination.total,
      };

    case GET_DISPUTE_DATA:
      return {
        ...state,
        disputeData: action.payload.data,
        totalDispute: Number(action.payload.pagination.total)
      };

    case GET_TRACK_STATUS:
      return {
        ...state,
        trackstatus: action.payload.data,
      }
    default:
      return state;
  }
};

export default userReducer;
